// ポップオーバーツールチップ（クリックで開閉）
var popoverInitialized = false;
document.addEventListener('turbolinks:load', function() {
  if (popoverInitialized) return;
  popoverInitialized = true;

  // イベント委譲で「?」ボタンのクリックを処理
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.popover-tooltip-trigger');

    if (trigger) {
      e.stopPropagation();
      var container = trigger.parentElement;
      var content = container.querySelector('.popover-tooltip-content');
      var isVisible = content.classList.contains('is-visible');

      // 他のポップオーバーを全て閉じる
      closeAllPopovers();

      // クリックしたものをトグル
      if (!isVisible) {
        content.classList.add('is-visible');
        trigger.setAttribute('aria-expanded', 'true');
      }
    } else {
      // ポップオーバーコンテンツ内のクリックは閉じない
      if (!e.target.closest('.popover-tooltip-content')) {
        closeAllPopovers();
      }
    }
  });

  // ESCキーで閉じる
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var hadVisible = closeAllPopovers();
      // 閉じた場合、フォーカスをトリガーボタンに戻す
      if (hadVisible) {
        var lastTrigger = document.querySelector('.popover-tooltip-trigger[aria-expanded="true"]');
        if (lastTrigger) {
          lastTrigger.focus();
        }
      }
    }
  });
});

function closeAllPopovers() {
  var visibleContents = document.querySelectorAll('.popover-tooltip-content.is-visible');
  visibleContents.forEach(function(el) {
    el.classList.remove('is-visible');
    var trigger = el.parentElement.querySelector('.popover-tooltip-trigger');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
  });
  return visibleContents.length > 0;
}
